import { IntegrationConnectionConfiguration } from './configuration';
import { IntegrationConnectionStatus } from './status';

export interface NoIntegrationConnection {
    type: 'NO_CONNECTION';
}

export function createNoIntegrationConnection(): NoIntegrationConnection {
    return {
        type: 'NO_CONNECTION',
    };
}

export interface IntegrationConnection {
    type: 'WITH_CONNECTION';

    configuration: IntegrationConnectionConfiguration;
    status: IntegrationConnectionStatus;
}

export function createIntegrationConnection(
    configuration: IntegrationConnectionConfiguration,
    status: IntegrationConnectionStatus,
): IntegrationConnection {
    return {
        configuration,
        status,
        type: 'WITH_CONNECTION',
    };
}

export type IntegrationConnectionOrNone = IntegrationConnection | NoIntegrationConnection;
